import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, styled, ThemeProvider } from '@mui/material/styles';
import useCaptcha from 'use-offline-captcha';
import RefreshIcon from '@mui/icons-material/Refresh';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, FormControl, FormHelperText, FormLabel, IconButton, MenuItem, Paper, Radio, RadioGroup, Slide, Stack, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import DoneIcon from '@mui/icons-material/Done';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function Copyright(props) {
    return (
        <Typography variant='body2' color="text.secondary" align='center' {...props}>
            {'Copyright © '}
            < Link color="inherit" href="https://wbsedcl.in/" >
                WEST BENGAL STATE ELECTRICITY DISTRIBUTION COMPANY LIMITED. All Rights Reserved.
            </Link > {' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography >
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme({
    components: {
        MuiFormLabel: {
            styleOverrides: {
                asterisk: {
                    color: "#db3131",
                    "&$error": {
                        color: "#db3131",
                    },
                },
            },
        },
    },
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const consumerIdPattern = /^\d{9,10}$/;
const mobileNumberPattern = /^\d{10}$/;
const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default function Form(props) {
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery('(min-width:350px)');
    const isBiggerScreen = useMediaQuery('(min-width:769px)');

    const [consumerId, setConsumerId] = useState("");
    const [consumerIdErrorMessage, setConsumerIdErrorMessage] = useState("");
    const [consumerIdDisabled, setConsumerIdDisabled] = useState(false);
    const [consumerIdValid, setConsumerIdValid] = useState(false);
    const [consumerIdError, setConsumerIdError] = useState(false);

    const [captchaText, setCaptchaText] = useState("");
    const [captchaTextErrorMessage, setCaptchaTextErrorMessage] = useState("");
    const [captchaTextValid, setCaptchaTextValid] = useState(false);
    const [captchaTextError, setCaptchaTextError] = useState(false);

    const [isMobileFetched, setIsMobileFetched] = useState(false);
    const [isMobileVerified, setIsMobileVerified] = useState(false);
    const [isOTPSent, setIsOTPSent] = useState(false);
    const [isFinalSubmitDone, setIsFinalSubmitDone] = useState(false);

    const [verifyLoading, setVerifyLoading] = useState(false);
    const [sendOtpLoading, setSendOtpLoading] = useState(false);
    const [otpVerifyLoading, setOtpVerifyLoading] = useState(false);
    const [finalSubmitLoading, setFinalSubmitLoading] = useState(false);

    const [hasMobileNumber, setHasMobileNumber] = useState(true);
    const [hideMobileEdit, setHideMobileEdit] = useState(true);

    const [consumerName, setConsumerName] = useState("");
    const [consumerNameErrorMessage, setConsumerNameErrorMessage] = useState("");
    const [consumerNameValid, setConsumerNameValid] = useState(false);
    const [consumerNameError, setConsumerNameError] = useState(false);

    const [consumerOriginalMobile, setConsumerOriginalMobile] = useState("");
    const [consumerMobile, setConsumerMobile] = useState("");
    const [consumerMobileErrorMessage, setConsumerMobileErrorMessage] = useState("");
    const [consumerMobileValid, setConsumerMobileValid] = useState(false);
    const [consumerMobileError, setConsumerMobileError] = useState(false);

    const [encryptedOtp, setEncryptedOtp] = useState("");
    const [otpGotFromApi, setOtpGotFromApi] = useState("");
    const [otp, setOtp] = useState("");//538240
    const [otpErrorMessage, setOtpErrorMessage] = useState("");
    const [otpValid, setOtpValid] = useState(false);
    const [otpError, setOtpError] = useState(false);

    const [supplyOfc, setSupplyOfc] = useState("");

    const [consumerEmail, setConsumerEmail] = useState("");
    const [consumerEmailErrorMessage, setConsumerEmailErrorMessage] = useState("");
    const [consumerEmailValid, setConsumerEmailValid] = useState(true);
    const [consumerEmailError, setConsumerEmailError] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(false);

    const [encryptedEmailOtp, setEncryptedEmailOtp] = useState("");
    const [emailOtpGotFromApi, setEmailOtpGotFromApi] = useState("");
    const [emailOtp, setEmailOtp] = useState("");//538240
    const [emailOtpErrorMessage, setEmailOtpErrorMessage] = useState("");
    const [emailOtpValid, setEmailOtpValid] = useState(false);
    const [emailOtpError, setEmailOtpError] = useState(false);
    const [isEmailOTPSent, setIsEmailOTPSent] = useState(false);
    const [sendEmailOtpLoading, setSendEmailOtpLoading] = useState(false);
    const [emailOtpVerifyLoading, setEmailOtpVerifyLoading] = useState(false);


    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine1ErrorMessage, setAddressLine1ErrorMessage] = useState("");
    const [addressLine1Valid, setAddressLine1Valid] = useState(false);
    const [addressLine1Error, setAddressLine1Error] = useState(false);

    const [addressLine2, setAddressLine2] = useState("");

    const [problemTypes, setProblemTypes] = useState([]);
    const [problemType, setProblemType] = useState("");
    const [problemTypeErrorMessage, setProblemTypeErrorMessage] = useState("");
    const [problemTypeValid, setProblemTypeValid] = useState(false);
    const [problemTypeError, setProblemTypeError] = useState(false);

    const [problemDesc, setProblemDesc] = useState("");
    const [problemDescErrorMessage, setProblemDescErrorMessage] = useState("");
    const [problemDescValid, setProblemDescValid] = useState(false);
    const [problemDescError, setProblemDescError] = useState(false);
    const [problemDescCount, setProblemDescCount] = useState(0);

    const [ackNumber, setAckNumber] = useState("");

    const [alignment, setAlignment] = useState('web');

    const handleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };

    const [grievanceOfc, setGrievanceOfc] = useState('');
    const [grievanceOfcValid, setGrievanceOfcValid] = useState(false);
    const [grievanceOfcError, setGrievanceOfcError] = useState(false);
    const [grievanceOfcHelperText, setGrievanceOfcHelperText] = useState('');

    const [supportingDoc, setSupportingDoc] = useState(null);
    const [supportingDocValid, setSupportingDocValid] = useState(false);
    const [supportingDocError, setSupportingDocError] = useState(false);
    const [supportingDocErrorMsg, setSupportingDocErrorMsg] = useState("Select not more than 1MB PDF File");

    const resetFrom = () => {
        setConsumerId("");
        setConsumerIdErrorMessage("");
        setConsumerIdDisabled(false);
        setConsumerIdValid(false);
        setConsumerIdError(false);

        setCaptchaText("");
        setCaptchaTextErrorMessage("");
        setCaptchaTextValid(false);
        setCaptchaTextError(false);

        setIsMobileFetched(false);
        setIsMobileVerified(false);
        setIsOTPSent(false);
        setIsFinalSubmitDone(false);

        setVerifyLoading(false);
        setSendOtpLoading(false);
        setOtpVerifyLoading(false);
        setFinalSubmitLoading(false);

        setHasMobileNumber(true);
        setHideMobileEdit(true);

        setConsumerName("");
        setConsumerNameErrorMessage("");
        setConsumerNameValid(false);
        setConsumerNameError(false);

        setConsumerOriginalMobile("");
        setConsumerMobile("");
        setConsumerMobileErrorMessage("");
        setConsumerMobileValid(false);
        setConsumerMobileError(false);

        setEncryptedOtp("");
        setOtpGotFromApi("");
        setOtp("");//538240
        setOtpErrorMessage("");
        setOtpValid(false);
        setOtpError(false);

        setSupplyOfc("");

        setConsumerEmail("");
        setConsumerEmailErrorMessage("");
        setConsumerEmailValid(true);
        setConsumerEmailError(false);

        setEncryptedEmailOtp("");
        setEmailOtpGotFromApi("");
        setEmailOtp("");//538240
        setEmailOtpErrorMessage("");
        setEmailOtpValid(false);
        setEmailOtpError(false);
        setIsEmailOTPSent(false);
        setSendEmailOtpLoading(false);
        setEmailOtpVerifyLoading(false);

        setAddressLine1("");
        setAddressLine1ErrorMessage("");
        setAddressLine1Valid(false);
        setAddressLine1Error(false);

        setAddressLine2("");

        setProblemType("");
        setProblemTypeErrorMessage("");
        setProblemTypeValid(false);
        setProblemTypeError(false);

        setProblemDesc("");
        setProblemDescErrorMessage("");
        setProblemDescValid(false);
        setProblemDescError(false);
        setProblemDescCount(0);

        setAckNumber("");

        setGrievanceOfc('');
        setGrievanceOfcValid(false);
        setGrievanceOfcError(false);
        setGrievanceOfcHelperText('');

        setSupportingDoc(null);
        setSupportingDocValid(false);
        setSupportingDocError(false);
        setSupportingDocErrorMsg("Select not more than 1MB PDF File");

        setTimer(0);
        setOpenErrorDialog(false);
        setErrorDialogMsg("");

        gen();
    }

    const handleGrievanceOfcChange = (event) => {
        setGrievanceOfc(event.target.value);
        if (event.target.value == "CGRO") {
            setGrievanceOfcHelperText('');
            setGrievanceOfcError(false);
            setGrievanceOfcValid(true);
        } else {
            setGrievanceOfcHelperText('');
            setGrievanceOfcError(false);
            setGrievanceOfcValid(true);
        }

    };

    const handleGrievanceFileChange = (event) => {
        const fileExt = event.target.files[0].name.split('.').pop();
        const fileSize = (event.target.files[0].size) / (1 * 1024 * 1024);
        if (fileExt == "pdf" && fileSize <= 1) {
            setSupportingDoc(event.target.files[0]);
            setSupportingDocErrorMsg('');
            setSupportingDocError(false);
            setSupportingDocValid(true);
        } else {
            setSupportingDoc(null);
            setSupportingDocValid(false);
            setSupportingDocError(true);
            if (fileExt != "pdf") {
                setSupportingDocErrorMsg('Please select pdf file only');
            }
            else if (fileSize > 1) {
                setSupportingDocErrorMsg('Please select pdf file with size not greater than 1 MB');
            }
            else {
                setGrievanceOfcHelperText('Something wrong with the file. try other file');
            }
        }
    };

    useEffect(() => {
        if (props && props.prepopulatedConsumerId && props.prepopulatedConsumerId.match(consumerIdPattern)) {
            console.log("cid valid");
            setConsumerIdErrorMessage("");
            setConsumerIdValid(true);
            setConsumerId(props.prepopulatedConsumerId);
            setConsumerIdDisabled(true);
        }
        else {
            setConsumerIdDisabled(false);
            setConsumerIdErrorMessage("");
            setConsumerIdValid(false);
        }

    }, [props.prepopulatedConsumerId])


    const captchaRef = useRef();
    const userOpt = {
        type: 'mixed', // "mixed"(default) | "numeric" | "alpha" 
        length: 5, // 4 to 8 number. default is 5
        sensitive: false, // Case sensitivity. default is false
        width: 200, // Canvas width. default is 200
        height: 44, // Canvas height. default is 50
        fontColor: '#000',
        background: 'rgba(255, 255, 255, .2)'
    }
    const { gen, validate } = useCaptcha(captchaRef, userOpt);

    useEffect(() => {
        if (gen) gen();
    }, [gen])

    const handleRefresh = () => { gen(); setCaptchaTextValid(false); }

    const handleSubmit = (event) => {
        event.preventDefault();
        // props.handleTableShow();
        console.log(consumerIdValid, captchaTextValid);
        if (consumerIdValid && captchaTextValid) {
            props.setLoading();
            const data = new FormData(event.currentTarget);
            const payload = {
                consumerId: consumerId,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            console.log({
                consumerId: consumerId,
                captcha: data.get('captcha'),
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            });
            setVerifyLoading(true);
            fetchConsumerContactDetails(payload);
        }
        else {
            // props.onVerifySubmit();
            if (!consumerIdValid && !captchaTextValid) {
                setConsumerIdError(true);
                setCaptchaTextError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Consumer Id")
                );
                setCaptchaTextErrorMessage(
                    t("Please enter captcha text")
                );
            }
            else if (!consumerIdValid) {
                setConsumerIdError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Consumer Id")
                );
            }
            else if (!captchaTextValid) {
                setCaptchaTextError(true);
                setCaptchaTextErrorMessage(
                    t("Please enter captcha text")
                );
            }
            else {
                setConsumerIdError(true);
                setCaptchaTextError(true);
                setConsumerIdErrorMessage(
                    t("Please enter Consumer Id")
                );
                setCaptchaTextErrorMessage(
                    t("Please enter captcha text")
                );
            }
        }
    };

    const fetchConsumerContactDetails = (inputData) => {
        const message = inputData.consumerId + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/FetchMobileNumberFromConId`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then((res) => {
            console.log(res.data, "Data");
            setVerifyLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.data?.mobileNumber) {
                    if ((data?.response?.data?.mobileNumber.match(mobileNumberPattern))) {
                        setConsumerMobileValid(true);
                        let maskedMobile = data?.response?.data?.mobileNumber.substring(0, 2) + "XXXXXX" + data?.response?.data?.mobileNumber.substring(data?.response?.data?.mobileNumber.length - 2, data?.response?.data?.mobileNumber.length);
                        setConsumerOriginalMobile(data?.response?.data?.mobileNumber);
                        setConsumerMobile(maskedMobile);
                    } else {
                        setConsumerMobileValid(false);
                        setConsumerOriginalMobile("");
                        setConsumerMobile("");
                    }

                    // if (data?.response?.data?.name && data?.response?.data?.name.length < 3) {
                    //     setConsumerNameValid(false);
                    // } else {
                    setConsumerNameValid(true);
                    // }
                    setConsumerName(data?.response?.data?.name);
                    setConsumerEmail(data?.response?.data?.email ?? "");
                    setConsumerEmailValid(data?.response?.data?.email?.match(emailPattern) ? true : !data?.response?.data?.email ? true : false);

                    setAddressLine1Valid(data?.response?.data?.address1?.length > 0 ? true : false);
                    setAddressLine1(data?.response?.data?.address1 ?? "");
                    setAddressLine2(data?.response?.data?.address2 ?? "");
                    setSupplyOfc(data?.response?.data?.supplyOfc);

                    setIsMobileFetched(true);
                    setHasMobileNumber(true);
                    setHideMobileEdit(true);


                }
                else {
                    setConsumerName(data?.response?.data?.name);
                    setConsumerNameValid(true);
                    setConsumerEmail(data?.response?.data?.email ?? "");
                    setConsumerEmailValid(data?.response?.data?.email?.match(emailPattern) ? true : !data?.response?.data?.email ? true : false);

                    setAddressLine1Valid(data?.response?.data?.address1?.length > 0 ? true : false);
                    setAddressLine1(data?.response?.data?.address1 ?? "");
                    setAddressLine2(data?.response?.data?.address2 ?? "");
                    setSupplyOfc(data?.response?.data?.supplyOfc);

                    setConsumerOriginalMobile("");
                    setConsumerMobile("");
                    setIsMobileFetched(true);
                    setHasMobileNumber(false);
                    setHideMobileEdit(false);
                }

                // setTimeout(() => {
                //   executeScroll(ref1);
                // }, 100);
                // executeScroll(ref1);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": {
                //             "msg": "Success",
                //             "address2": "DIST-24PGS (S)",
                //             "address1": "VILL-LANGALBARIA",
                //             "mobileNumber": null,
                //             "supplyOfc": "MAHINAGAR CCC-3113500",
                //             "name": "GOBINDA CH.GHOSH",
                //             "email": null,
                //             "status": "Y"
                //         },
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // }
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": {
                            "msg": "Success",
                            "address2": "DIST-24PGS (S)",
                            "address1": "VILL-LANGALBARIA",
                            "mobileNumber": "9090909090",
                            "supplyOfc": "MAHINAGAR CCC-3113500",
                            "name": "DIP DDG",
                            "email": null,
                            "status": "Y"
                        },
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }

                // if (data?.response?.data?.mobileNumber) {
                //     if ((data?.response?.data?.mobileNumber.match(mobileNumberPattern))) {
                //         setConsumerMobileValid(true);
                //         let maskedMobile = data?.response?.data?.mobileNumber.substring(0, 2) + "XXXXXX" + data?.response?.data?.mobileNumber.substring(data?.response?.data?.mobileNumber.length - 2, data?.response?.data?.mobileNumber.length);
                //         setConsumerOriginalMobile(data?.response?.data?.mobileNumber);
                //         setConsumerMobile(maskedMobile);
                //     } else {
                //         setConsumerMobileValid(false);
                //         setConsumerOriginalMobile("");
                //         setConsumerMobile("");
                //     }

                //     // if (data?.response?.data?.name && data?.response?.data?.name.length < 3) {
                //     //     setConsumerNameValid(false);
                //     // } else {
                //     setConsumerNameValid(true);
                //     // }
                //     setConsumerName(data?.response?.data?.name);
                //     setConsumerEmail(data?.response?.data?.email ?? "");
                //     setConsumerEmailValid(data?.response?.data?.email?.match(emailPattern) ? true : !data?.response?.data?.email ? true : false);

                //     setAddressLine1Valid(data?.response?.data?.address1?.length > 0 ? true : false);
                //     setAddressLine1(data?.response?.data?.address1 ?? "");
                //     setAddressLine2(data?.response?.data?.address2 ?? "");
                //     setSupplyOfc(data?.response?.data?.supplyOfc);

                //     setIsMobileFetched(true);
                //     setHasMobileNumber(true);
                //     setHideMobileEdit(true);


                // }
                // else {
                //     setConsumerName(data?.response?.data?.name);
                //     setConsumerNameValid(true);
                //     setConsumerEmail(data?.response?.data?.email ?? "");
                //     setConsumerEmailValid(data?.response?.data?.email?.match(emailPattern) ? true : !data?.response?.data?.email ? true : false);

                //     setAddressLine1Valid(data?.response?.data?.address1?.length > 0 ? true : false);
                //     setAddressLine1(data?.response?.data?.address1 ?? "");
                //     setAddressLine2(data?.response?.data?.address2 ?? "");
                //     setSupplyOfc(data?.response?.data?.supplyOfc);

                //     setConsumerOriginalMobile("");
                //     setConsumerMobile("");
                //     setIsMobileFetched(true);
                //     setHasMobileNumber(false);
                //     setHideMobileEdit(false);
                // }



                handleClickOpenErrorDialog("Something went wrong");
                setVerifyLoading(false);
            })
    }

    const onClickSendOTP = () => {
        console.log(consumerNameValid, consumerMobileValid);

        if (consumerNameValid && consumerMobileValid) {
            setSendOtpLoading(true);
            // const data = new FormData(event.currentTarget);
            const payload = {
                mobileNumber: consumerMobile.includes("XXX") ? consumerOriginalMobile : consumerMobile,
                reSendOtp: "",
                flag: "S"
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            console.log({
                mobileNumber: consumerMobile.includes("XXX") ? consumerOriginalMobile : consumerMobile,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            });
            sendOTP(payload);
        }
        else {
            // props.onVerifySubmit();
            if (!consumerNameValid && !consumerMobileValid) {
                setConsumerNameError(true);
                setConsumerMobileError(true);

                setConsumerNameErrorMessage(
                    t("Please enter valid Consumer Name")
                );
                setConsumerMobileErrorMessage(
                    t("Please enter valid mobile number")
                );
            }
            else if (!consumerMobileValid) {
                setConsumerMobileError(true);
                setConsumerMobileErrorMessage(
                    t("Please enter valid mobile number")
                );
            }
            else if (!consumerNameValid) {
                setConsumerNameError(true);
                setConsumerNameErrorMessage(
                    t("Please enter valid Consumer Name")
                );
            }
            else {
                setConsumerNameError(true);
                setConsumerMobileError(true);

                setConsumerNameErrorMessage(
                    t("Please enter Consumer Name")
                );
                setConsumerMobileErrorMessage(
                    t("Please enter mobile number")
                );
            }
        }
    }

    const sendOTP = (inputData) => {
        const message = inputData.mobileNumber + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/SendOTP`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then((res) => {
            console.log(res.data, "Data");
            setSendOtpLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.data?.otpValue) {
                    let otp = decryptOtp(data?.response?.data?.otpValue);
                    setEncryptedOtp(data?.response?.data?.otpValue);
                    setOtpGotFromApi(otp);
                    setOtp("");

                    resetTimer();
                    setIsOTPSent(true);
                    setHideMobileEdit(false);
                    setIsMobileFetched(true);
                }
                else {
                    setEncryptedOtp("");
                    setOtpGotFromApi("");
                    setOtp("");
                    setIsOTPSent(false);
                    setHideMobileEdit(true);
                    setIsMobileFetched(true);
                }

                // setTimeout(() => {
                //   executeScroll(ref1);
                // }, 100);
                // executeScroll(ref1);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": {
                            "otpValue": "Ytegtd1lIskq60gIA7cqjA=="
                        },
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }

                // if (data?.response?.data?.otpValue) {
                //     let otp = decryptOtp(data?.response?.data?.otpValue);
                //     setEncryptedOtp(data?.response?.data?.otpValue);
                //     setOtpGotFromApi(otp);
                //     setOtp("");

                //     resetTimer();
                //     setIsOTPSent(true);
                //     setHideMobileEdit(false);
                //     setIsMobileFetched(true);
                // }
                // else {
                //     setEncryptedOtp("");
                //     setOtpGotFromApi("");
                //     setOtp("");
                //     setIsOTPSent(false);
                //     setHideMobileEdit(true);
                //     setIsMobileFetched(true);
                // }

                handleClickOpenErrorDialog("Something went wrong");
                setSendOtpLoading(false);
            })
    }

    const onClickSendEmailOTP = () => {
        if (consumerEmail.length > 0 && consumerEmailValid) {
            setSendEmailOtpLoading(true);
            // const data = new FormData(event.currentTarget);
            const payload = {
                email: consumerEmail,
                consumerName: consumerName
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            console.log({
                email: consumerEmail,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            });
            sendEmailOTP(payload);
        }
        else {
            // props.onVerifySubmit();
            if (consumerEmail.length == 0 && !consumerEmailValid) {
                setConsumerEmailError(true);

                setConsumerEmailErrorMessage(
                    t("Please enter valid Email")
                );
            }
            else if (consumerEmail.length == 0) {
                setConsumerEmailError(true);

                setConsumerEmailErrorMessage(
                    t("Please enter Email")
                );
            }
            else if (!consumerEmailValid) {
                setConsumerEmailError(true);

                setConsumerEmailErrorMessage(
                    t("Please enter valid Email")
                );
            }
            else {
                setConsumerEmailError(true);

                setConsumerEmailErrorMessage(
                    t("Please enter valid Email")
                );
            }
        }
    }

    const sendEmailOTP = (inputData) => {
        const message = inputData.mobileNumber + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/SendEmailOTP`, {
            ...inputData,
            checkSum: encData
        }, {
            headers: {
                "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
            }
        }).then((res) => {
            console.log(res.data, "Data");
            setSendEmailOtpLoading(false);
            if (typeof res.data == "string") {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                // setLoading(false);
            }
            else if (res.data?.EXCEPTION) {
                // setErrorMsg(res.data?.EXCEPTION);
                // handleErrorBar();
                // setLoading(false);
            }
            else {
                let data = res.data;
                if (data?.response?.data?.otpValue) {
                    let otp = decryptOtp(data?.response?.data?.otpValue);
                    setEncryptedEmailOtp(data?.response?.data?.otpValue);
                    setEmailOtpGotFromApi(otp);
                    setEmailOtp("");

                    resetTimer();
                    setIsEmailOTPSent(true);
                }
                else {
                    setEncryptedEmailOtp("");
                    setEmailOtpGotFromApi("");
                    setEmailOtp("");
                    setIsEmailOTPSent(false);
                }

                // setTimeout(() => {
                //   executeScroll(ref1);
                // }, 100);
                // executeScroll(ref1);
            }
        })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                console.log(err, "Error");
                let data = {
                    "response": {
                        "errorDescription": null,
                        "data": {
                            "otpValue": "Ytegtd1lIskq60gIA7cqjA=="
                        },
                        "message": null,
                        "status": true,
                        "statusCode": 0
                    }
                }

                // if (data?.response?.data?.otpValue) {
                //     let otp = decryptOtp(data?.response?.data?.otpValue);
                //     setEncryptedEmailOtp(data?.response?.data?.otpValue);
                //     setEmailOtpGotFromApi(otp);
                //     setEmailOtp("");

                //     resetTimer();
                //     setIsEmailOTPSent(true);
                // }
                // else {
                //     setEncryptedEmailOtp("");
                //     setEmailOtpGotFromApi("");
                //     setEmailOtp("");
                //     setIsEmailOTPSent(false);
                // }

                handleClickOpenErrorDialog("Something went wrong");
                setSendEmailOtpLoading(false);
            })
    }

    const onClickVerifyEmailOTP = async () => {
        setEmailOtpVerifyLoading(true);
        let isOtpValid = false;
        if (emailOtp && emailOtp.length < 6) {
            setEmailOtpError(true);
        } else {
            setEmailOtpError(false);
        }

        if (!emailOtp) {
            setEmailOtpErrorMessage(
                t("Please enter otp")
            );
        }
        else if (emailOtp?.trim().length < 6) {
            setEmailOtpErrorMessage(
                t("Please enter valid otp")
            );
        }

        if (emailOtp && emailOtp?.trim().length == 6 && emailOtpErrorMessage) {
            setEmailOtpErrorMessage("");
            setEmailOtpValid(true);
            isOtpValid = true;
        }
        else if (emailOtp && emailOtp?.trim().length == 6 && !emailOtpErrorMessage) {
            setEmailOtpErrorMessage("");
            setEmailOtpValid(true);
            isOtpValid = true;
        }
        else if (!emailOtp && emailOtpErrorMessage) {
            setEmailOtpErrorMessage("");
            setEmailOtpValid(false);
            isOtpValid = false;
        }
        else {
            setEmailOtpValid(false);
            isOtpValid = false;
        }


        if (isOtpValid) {
            if (emailOtp == emailOtpGotFromApi) {
                setIsEmailVerified(true);
                setTimer(0);
                setEmailOtpVerifyLoading(false);
            } else {
                setIsEmailVerified(false);
                setEmailOtpVerifyLoading(false);
                setEmailOtpError(true);
                setEmailOtpErrorMessage(
                    t("Please enter valid otp")
                );
            }
        }
        else {
            setIsEmailVerified(false);
            setEmailOtpVerifyLoading(false);
            setEmailOtpError(true);
            setEmailOtpErrorMessage(
                t("Please enter valid otp")
            );
        }
    }

    useEffect(() => {
        console.log(problemType, "&&&&&&");
    }, [problemType])


    const fetchProblemTypes = async (inputData) => {
        return new Promise((resolve, reject) => {
            const message = dayjs().format("YYYYMMDD");
            console.log(message);
            const secret = process.env.REACT_APP_ENC_SECRET_KEY;
            const cipherText = CryptoJS.HmacSHA256(message, secret);
            const encData = cipherText.toString(CryptoJS.enc.Base64);
            console.log(encData, "encData");

            axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/FetchProblemTypes`, {
                ...inputData,
                checkSum: encData
            }, {
                headers: {
                    "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`)
                }
            }).then((res) => {
                console.log(res.data, "Data");
                setSendOtpLoading(false);
                if (typeof res.data == "string") {
                    resolve();
                    // setErrorMsg(t("Something went wrong. Please try again later"));
                    // handleErrorBar();
                    // setLoading(false);
                }
                else if (res.data?.EXCEPTION) {
                    resolve();
                    // setErrorMsg(res.data?.EXCEPTION);
                    // handleErrorBar();
                    // setLoading(false);
                }
                else {
                    let data = res.data;
                    if (data?.response?.data?.length > 0) {
                        setProblemTypes(data?.response?.data);
                    }
                    else {
                        setProblemTypes([]);
                    }
                    resolve();
                }
            })
                .catch((err) => {
                    // setErrorMsg(t("Something went wrong. Please try again later"));
                    // handleErrorBar();
                    console.log(err, "Error");
                    let data = {
                        "response": {
                            "errorDescription": null,
                            "data": [
                                "Billing related problem",
                                "Problem in effecting new connection"
                            ],
                            "message": null,
                            "status": true,
                            "statusCode": 0
                        }
                    }

                    // if (data?.response?.data?.length > 0) {
                    //     setProblemTypes(data?.response?.data);
                    // }
                    // else {
                    //     setProblemTypes([]);
                    // }
                    // resolve();


                    setProblemTypes([]);
                    reject();
                })
        })
    }

    const onClickEditMobileButton = () => {
        setConsumerMobile("");
        setHideMobileEdit(false);
        setHasMobileNumber(false);
        setConsumerMobileValid(false);
    }

    const decryptOtp = (encryptedOTP) => {
        let encryptedBase64Key = process.env.REACT_APP_QUERY_STRING_SECRET_KEY;
        let parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

        let encryptedCipherText = encryptedOTP;

        let decryptedData = CryptoJS.AES.decrypt(encryptedCipherText, parsedBase64Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        let decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
        console.log("DecryptedText = " + decryptedText);
        return decryptedText;
    }

    const onClickVerifyOTP = async () => {
        let isOtpValid = false;
        if (otp && otp.length < 6) {
            setOtpError(true);
        } else {
            setOtpError(false);
        }

        if (!otp) {
            setOtpErrorMessage(
                t("Please enter otp")
            );
        }
        else if (otp?.trim().length < 6) {
            setOtpErrorMessage(
                t("Please enter valid otp")
            );
        }

        if (otp && otp?.trim().length == 6 && otpErrorMessage) {
            setOtpErrorMessage("");
            setOtpValid(true);
            isOtpValid = true;
        }
        else if (otp && otp?.trim().length == 6 && !otpErrorMessage) {
            setOtpErrorMessage("");
            setOtpValid(true);
            isOtpValid = true;
        }
        else if (!otp && otpErrorMessage) {
            setOtpErrorMessage("");
            setOtpValid(false);
            isOtpValid = false;
        }
        else {
            setOtpValid(false);
            isOtpValid = false;
        }


        if (isOtpValid) {
            setOtpVerifyLoading(true);
            // const data = new FormData(event.currentTarget);
            if (otp == otpGotFromApi) {
                await fetchProblemTypes({})
                    .then((prob) => {
                        setIsMobileVerified(true);
                        setIsMobileFetched(true);
                        setHideMobileEdit(false);
                        setTimer(0);
                        setConsumerMobile(consumerMobile.includes("XXX") ? consumerOriginalMobile : consumerMobile);

                        setOtpVerifyLoading(false);
                    })
                    .catch((e) => {
                        // setIsMobileVerified(true);
                        // setIsMobileFetched(true);
                        // setHideMobileEdit(false);
                        // setTimer(0);
                        // setConsumerMobile(consumerMobile.includes("XXX") ? consumerOriginalMobile : consumerMobile);

                        handleClickOpenErrorDialog("Something went wrong");
                        setOtpVerifyLoading(false);
                    });

            } else {
                setOtpError(true);
                setOtpErrorMessage(
                    t("Please enter valid otp")
                );
                setIsMobileVerified(false);
                setIsMobileFetched(true);
                setHideMobileEdit(false);
            }
        }
        else {
            setOtpError(true);

            setOtpErrorMessage(
                t("Please enter valid otp")
            );
        }
    }

    const [timer, setTimer] = useState(0);
    const timeOutCallback = useCallback(() => setTimer(currTimer => currTimer - 1), []);

    useEffect(() => {
        timer > 0 && setTimeout(timeOutCallback, 1000);
    }, [timer, timeOutCallback]);

    // console.log(timer);

    const resetTimer = function () {
        setTimer(120);
    };

    const onClickFinalSubmit = () => {
        console.log(consumerIdValid, consumerNameValid, consumerMobileValid, addressLine1Valid, consumerEmailValid, problemTypeValid, problemDescValid, grievanceOfcValid, supportingDocValid);
        if (consumerIdValid && consumerNameValid && consumerMobileValid && addressLine1Valid && consumerEmailValid && problemTypeValid && problemDescValid && grievanceOfcValid && supportingDocValid) {
            setFinalSubmitLoading(true);
            const data = new FormData();

            const payload = {
                ConsumerID: consumerId,
                ApplicationNo: consumerId,
                MobileNumber: consumerMobile,
                Name: consumerName,
                Address: addressLine1 + (addressLine2 ? (", " + addressLine2) : ""),
                EmailId: consumerEmail,
                ProblemDescription: problemDesc,
                grievanceOfc: grievanceOfc,
                ProblemType: problemType,
                // fromDate: dayjs(data.get('fromDate'), "DD/MM/YYYY").format("YYYYMMDD"),
                // toDate: dayjs(data.get('toDate'), "DD/MM/YYYY").format("YYYYMMDD")
            };
            submitGrievanceDetails(payload);
        }
        else {
            // props.onVerifySubmit();
            if (!addressLine1Valid && !consumerEmailValid && !problemTypeValid && !problemDescValid && !grievanceOfcValid && !supportingDocValid) {
                setAddressLine1Error(true);
                setConsumerEmailError(true);
                setProblemTypeError(true);
                setProblemDescError(true);
                setGrievanceOfcError(true);
                setSupportingDocError(true);

                setAddressLine1ErrorMessage(t("Please enter valid address"));
                setConsumerEmailErrorMessage(t("Please enter valid email"));
                setProblemTypeErrorMessage(
                    t("Please select problem type")
                );
                setProblemDescErrorMessage(
                    t("Please enter problem description")
                );
                setGrievanceOfcHelperText(
                    t("Please select grievance office")
                );
                setSupportingDocErrorMsg(t("Please select valid file"));
            }
            else if (!addressLine1Valid) {
                setAddressLine1Error(true);
                setAddressLine1ErrorMessage(t("Please enter valid address"));
            }
            else if (!consumerEmailValid) {
                setConsumerEmailError(true);
                setConsumerEmailErrorMessage(t("Please enter valid email"));
            }
            else if (!problemTypeValid) {
                setProblemTypeError(true);
                setProblemTypeErrorMessage(
                    t("Please select problem type")
                );
            }
            else if (!problemDescValid) {
                setProblemDescError(true);
                setProblemDescErrorMessage(
                    t("Please enter problem description")
                );
            }
            else if (!grievanceOfcValid) {
                setGrievanceOfcError(true);
                setGrievanceOfcHelperText(
                    t("Please select grievance office")
                );
            }
            else if (!supportingDocValid) {
                setSupportingDocError(true);
                setSupportingDocErrorMsg(t("Please select valid file"));
            }
            else {
                handleClickOpenErrorDialog("Please fill all mandatory fields");
            }
        }
    };

    const submitGrievanceDetails = (inputData) => {
        const message = inputData.consumerId + dayjs().format("YYYYMMDD");
        console.log(message);
        const secret = process.env.REACT_APP_ENC_SECRET_KEY;
        const cipherText = CryptoJS.HmacSHA256(message, secret);
        const encData = cipherText.toString(CryptoJS.enc.Base64);
        console.log(encData, "encData");

        const formData = new FormData();
        formData.append('ConsumerID', inputData.ConsumerID);
        formData.append('ApplicationNo', inputData.ApplicationNo);
        formData.append('MobileNumber', inputData.MobileNumber);
        formData.append('Name', inputData.Name);
        formData.append('Address', inputData.Address);
        formData.append('EmailId', inputData.EmailId);
        formData.append('ProblemDescription', inputData.ProblemDescription);
        formData.append('grievanceOfc', inputData.grievanceOfc);
        formData.append('file', supportingDoc);
        formData.append('ProblemType', inputData.ProblemType);

        axios.post(`${process.env.REACT_APP_API_URL}GrievanceRedressal/SubmitGrievanceDetails`,
            formData,
            {
                headers: {
                    "Authorization": "Basic " + btoa(`${process.env.REACT_APP_BASIC_AUTH_USERNAME}:${process.env.REACT_APP_BASIC_AUTH_PASSWORD}`),
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                console.log(res.data, "Data");
                setFinalSubmitLoading(false);
                if (typeof res.data == "string") {
                    // setErrorMsg(t("Something went wrong. Please try again later"));
                    // handleErrorBar();
                    // setLoading(false);
                }
                else if (res.data?.EXCEPTION) {
                    // setErrorMsg(res.data?.EXCEPTION);
                    // handleErrorBar();
                    // setLoading(false);
                }
                else {
                    let data = res.data;

                    if (data?.response?.status && data?.response?.data?.AckNum) {
                        setIsFinalSubmitDone(true);
                        setAckNumber(data?.response?.data?.AckNum);
                    }
                    else {
                        setIsFinalSubmitDone(false);
                        handleClickOpenErrorDialog(data?.response?.data?.Message ?? "Something went wrong");
                    }
                }
            })
            .catch((err) => {
                // setErrorMsg(t("Something went wrong. Please try again later"));
                // handleErrorBar();
                setFinalSubmitLoading(false);
                handleClickOpenErrorDialog("Something went wrong");
                console.log(err, "Error");
                // let data = {
                //     "response": {
                //         "errorDescription": null,
                //         "data": {
                //             "AckNum": "135",
                //             "Message": "You have succesfully submit your greivance!",
                //             "DocumentUploadFlag": "Y",
                //             "DocumentDBSaveFlag": "Y"
                //         },
                //         "message": null,
                //         "status": true,
                //         "statusCode": 0
                //     }
                // };

                // if (data?.response?.status && data?.response?.data?.AckNum) {
                //     setIsFinalSubmitDone(true);
                //     setAckNumber(data?.response?.data?.AckNum);
                // }
                // else {
                //     setIsFinalSubmitDone(false);
                //     handleClickOpenErrorDialog(data?.response?.data?.Message ?? "Something went wrong");
                // }
            })
    }


    const changeLang = () => {
        if (i18n.language == "en") {
            i18n.changeLanguage("bn")
        } else {
            i18n.changeLanguage("en")
        }
    }


    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errorDialogMsg, setErrorDialogMsg] = useState("");

    const handleClickOpenErrorDialog = (msg) => {
        setOpenErrorDialog(true);
        setErrorDialogMsg(msg);
    };

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);
        setErrorDialogMsg("");
    };

    const resetEmailForm = () => {
        setConsumerEmail("");
        setConsumerEmailErrorMessage("");
        setConsumerEmailValid(true);
        setConsumerEmailError(false);

        setEncryptedEmailOtp("");
        setEmailOtpGotFromApi("");
        setEmailOtp("");//538240
        setEmailOtpErrorMessage("");
        setEmailOtpValid(false);
        setEmailOtpError(false);
        setIsEmailOTPSent(false);
        setSendEmailOtpLoading(false);
        setEmailOtpVerifyLoading(false);
    }

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="lg">
                <CssBaseline />
                <Dialog
                    open={openErrorDialog}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleCloseErrorDialog}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Error"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {errorDialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseErrorDialog}>OK</Button>
                    </DialogActions>
                </Dialog>


                {/* <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: matches ? 120 : 160,
                    right: 6,
                    display: { xs: 'block', sm: "none", md: 'none', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 120,
                    right: 6,
                    display: { xs: 'none', sm: "block", md: 'none', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 112,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'block', lg: 'none', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 120,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'none', lg: 'block', xl: "none" }
                }}>
                    {t("English")}
                </Fab>
                <Fab onClick={changeLang} color="primary" aria-label="add" variant="extended" sx={{
                    position: "absolute",
                    top: 125,
                    right: 6,
                    display: { xs: 'none', sm: "none", md: 'none', lg: 'none', xl: "block" }
                }}>
                    {t("English")}
                </Fab> */}
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <img src="images/logo.png" className="img-fluid" alt="WBSEDCL" />
                    {/* <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <img src="images/logo.png" height={24} width={24} className="img-fluid" alt="WBSEDCL" />
                    </Avatar> */}
                    <Typography component="h1" variant="h5" textAlign={"center"} sx={{ mt: 2 }}>
                        {t("Register Your Grievance (CGRO/RGRO)")}
                    </Typography>
                    {
                        isFinalSubmitDone &&
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // minHeight: '100vh'
                                mt: 5
                            }}
                        >
                            <Container>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12 }}>
                                        <Paper elevation={3} className="boxPaper" sx={{
                                            transition: 'linear 0.6s',
                                            color: 'primary.main',
                                            '&:hover': {
                                                backgroundColor: 'primary.main',
                                                color: '#fff',
                                                // boxShadow: '0px 0px 8px 3px rgba(0,0,0,0.5)',
                                            },
                                            padding: 10,
                                            textAlign: "center",
                                            alignItems: 'center',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            color: '#005696',
                                            letterSpacing: 1,
                                            cursor: 'pointer',
                                            flexDirection: "column"
                                        }}>
                                            {t("Your Grievance is successfully submitted.")}<br />
                                            {t("The Acknowledgement Number for future reference is")}
                                            <br />
                                            <p style={{ color: 'red' }}>{ackNumber}</p>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Box>
                    }
                    {!isFinalSubmitDone &&
                        <div style={{ width: isBiggerScreen ? "67%" : "100%" }}>
                            <Box component="form" maxWidth="lg" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <TextField
                                            required
                                            fullWidth
                                            disabled={consumerIdDisabled}
                                            id="consumerId"
                                            label={t("Consumer Id")}
                                            name="consumerId"
                                            autoComplete="consumerId"
                                            helperText={consumerIdErrorMessage}
                                            value={consumerId}
                                            slotProps={{
                                                input: {
                                                    readOnly: isMobileFetched,
                                                },
                                            }}
                                            // onInput={(e)=>{console.log(e);}}
                                            onInput={(e) => {
                                                console.log("cid fired");
                                                setConsumerId(e.target.value);
                                                if ((e.target.value && e.target.value.match(consumerIdPattern))) {
                                                    setConsumerIdError(false);
                                                } else {
                                                    setConsumerIdError(true);
                                                }

                                                if (!e.target.value) {
                                                    setConsumerIdErrorMessage(
                                                        t("Please enter Consumer Id")
                                                    );
                                                }
                                                else if (!e.target.value.match(consumerIdPattern)) {
                                                    setConsumerIdErrorMessage(
                                                        t("Please enter valid Consumer Id")
                                                    );
                                                }
                                                console.log(consumerIdErrorMessage);
                                                if (e.target.value.match(consumerIdPattern) && consumerIdErrorMessage) {
                                                    console.log("cid valid");
                                                    setConsumerIdErrorMessage("");
                                                    setConsumerIdValid(true);
                                                }
                                                else if (e.target.value.match(consumerIdPattern) && !consumerIdErrorMessage) {
                                                    console.log("cid valid");
                                                    setConsumerIdErrorMessage("");
                                                    setConsumerIdValid(true);
                                                }
                                                else if (e.target.value.length == 0 && consumerIdErrorMessage) {
                                                    setConsumerIdErrorMessage("");
                                                    setConsumerIdValid(false);
                                                }
                                                else {
                                                    setConsumerIdValid(false);
                                                }

                                            }}
                                            error={consumerIdError}
                                        />
                                    </Grid>
                                    {!isMobileFetched &&
                                        <Grid size={12}>
                                            <TextField
                                                required
                                                fullWidth
                                                name="captcha"
                                                label={t("Captcha Text")}
                                                type="text"
                                                id="captcha"
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                helperText={captchaTextErrorMessage}
                                                value={captchaText}
                                                onInput={(e) => {
                                                    setCaptchaText(e.target.value.toUpperCase());
                                                    if (e.target.value && e.target.value.length == 5 && validate(e.target.value)) {
                                                        setCaptchaTextError(false);
                                                    } else {
                                                        setCaptchaTextError(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setCaptchaTextErrorMessage(
                                                            t("Please enter captcha text")
                                                        );
                                                    }
                                                    else if (e.target.value?.trim().length != 5 && !validate(e.target.value)) {
                                                        setCaptchaTextErrorMessage(
                                                            t("Please enter valid captcha text")
                                                        );
                                                    }

                                                    if (e.target.value && e.target.value?.trim().length == 5 && validate(e.target.value) && captchaTextErrorMessage) {
                                                        setCaptchaTextErrorMessage("");
                                                        setCaptchaTextValid(true);
                                                    }
                                                    else if (e.target.value && e.target.value?.trim().length == 5 && validate(e.target.value) && !captchaTextErrorMessage) {
                                                        setCaptchaTextErrorMessage("");
                                                        setCaptchaTextValid(true);
                                                    }
                                                    else if (!e.target.value && captchaTextErrorMessage) {
                                                        setCaptchaTextErrorMessage("");
                                                        setCaptchaTextValid(false);
                                                    }
                                                    else {
                                                        setCaptchaTextValid(false);
                                                    }
                                                }}
                                                error={captchaTextError}
                                            />
                                        </Grid>
                                    }
                                    <Grid size={{ xs: 8, sm: 6, xl: 4, md: 4, lg: 4 }} sx={{ alignSelf: "flex-end", display: !isMobileFetched ? 'block' : 'none' }}>
                                        <div ref={captchaRef} className="captcha" />
                                    </Grid>
                                    {!isMobileFetched &&
                                        <Grid size={{ xs: 4, sm: 6, xl: 8, md: 8, lg: 8 }} justifySelf="flex-end">
                                            <Button variant="contained" onClick={handleRefresh} startIcon={<RefreshIcon fontSize="large" />} sx={{ textTransform: 'capitalize', fontSize: '13px', height: '44px' }} >{t("Refresh")}</Button>
                                        </Grid>
                                    }


                                    {isMobileFetched && <>
                                        <Grid size={12}>
                                            <TextField
                                                required
                                                fullWidth
                                                name="consumerName"
                                                label={t("Consumer Name")}
                                                type="text"
                                                id="consumerName"
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                helperText={consumerNameErrorMessage}
                                                value={consumerName}
                                                slotProps={{
                                                    input: {
                                                        readOnly: isMobileFetched,
                                                    },
                                                }}
                                                onInput={(e) => {
                                                    setConsumerName(e.target.value);
                                                    if (e.target.value && e.target.value.length >= 3) {
                                                        setConsumerNameError(false);
                                                    } else {
                                                        setConsumerNameError(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setConsumerNameErrorMessage(
                                                            t("Please enter name")
                                                        );
                                                    }
                                                    else if (e.target.value?.trim().length < 3) {
                                                        setConsumerNameErrorMessage(
                                                            t("Please enter valid name")
                                                        );
                                                    }

                                                    if (e.target.value && e.target.value?.trim().length >= 3 && consumerNameErrorMessage) {
                                                        setConsumerNameErrorMessage("");
                                                        setConsumerNameValid(true);
                                                    }
                                                    else if (e.target.value && e.target.value?.trim().length >= 3 && !captchaTextErrorMessage) {
                                                        setConsumerNameErrorMessage("");
                                                        setConsumerNameValid(true);
                                                    }
                                                    else if (!e.target.value && consumerNameErrorMessage) {
                                                        setConsumerNameErrorMessage("");
                                                        setConsumerNameValid(false);
                                                    }
                                                    else {
                                                        setConsumerNameValid(false);
                                                    }
                                                }}
                                                error={consumerNameError}
                                            />
                                        </Grid>

                                        <Grid size={12}>
                                            <Stack direction="row" spacing={1} style={{ width: '100%', marginBottom: '10px', position: 'relative' }}>
                                                <TextField
                                                    required
                                                    fullWidth
                                                    name="mobile"
                                                    label={t("Mobile Number")}
                                                    type="text"
                                                    id="mobile"
                                                    autoComplete="false"
                                                    disabled={hasMobileNumber || isOTPSent || isMobileVerified}
                                                    // inputProps={{ maxLength: 5 }}
                                                    helperText={consumerMobileErrorMessage}
                                                    value={consumerMobile}
                                                    onInput={(e) => {
                                                        console.log("cid fired");
                                                        setConsumerMobile(e.target.value);
                                                        if ((e.target.value && e.target.value.match(mobileNumberPattern))) {
                                                            setConsumerMobileError(false);
                                                        } else {
                                                            setConsumerMobileError(true);
                                                        }

                                                        if (!e.target.value) {
                                                            setConsumerMobileErrorMessage(
                                                                t("Please enter mobile number")
                                                            );
                                                        }
                                                        else if (!e.target.value.match(mobileNumberPattern)) {
                                                            setConsumerMobileErrorMessage(
                                                                t("Please enter valid mobile number")
                                                            );
                                                        }
                                                        console.log(consumerMobileErrorMessage);
                                                        if (e.target.value.match(mobileNumberPattern) && consumerMobileErrorMessage) {
                                                            console.log("cid valid");
                                                            setConsumerMobileErrorMessage("");
                                                            setConsumerMobileValid(true);
                                                        }
                                                        else if (e.target.value.match(mobileNumberPattern) && !consumerMobileErrorMessage) {
                                                            console.log("cid valid");
                                                            setConsumerMobileErrorMessage("");
                                                            setConsumerMobileValid(true);
                                                        }
                                                        else if (e.target.value.length == 0 && consumerMobileErrorMessage) {
                                                            setConsumerMobileErrorMessage("");
                                                            setConsumerMobileValid(false);
                                                        }
                                                        else {
                                                            setConsumerMobileValid(false);
                                                        }

                                                    }}
                                                    error={consumerMobileError}
                                                />
                                                {hasMobileNumber ?
                                                    <IconButton size="small" variant="contained" color="info" onClick={onClickEditMobileButton} className='editBtnSt' sx={{
                                                        right: '10px',
                                                        top: '12px',
                                                        margin: '0px !important',
                                                        borderLeftWidth: 10,
                                                        borderLeftColor: "#000",
                                                        position: 'absolute !important'
                                                    }}>
                                                        {hideMobileEdit ? <EditTwoToneIcon /> : null}

                                                        {/* {hideMobileEdit ? <EditTwoToneIcon /> : <DoneIcon />} */}
                                                    </IconButton >
                                                    :
                                                    null
                                                }
                                            </Stack>
                                        </Grid>
                                        {isOTPSent && !isMobileVerified && <Grid size={12}>
                                            <TextField
                                                required
                                                fullWidth
                                                name="otp"
                                                label={t("OTP")}
                                                type="text"
                                                id="otp"
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                helperText={otpErrorMessage}
                                                value={otp}
                                                // slotProps={{
                                                //     input: {
                                                //         readOnly: isMobileFetched,
                                                //     },
                                                // }}
                                                onInput={(e) => {
                                                    setOtp(e.target.value);
                                                    // if (e.target.value && e.target.value.length < 3) {
                                                    //     setConsumerNameError(false);
                                                    // } else {
                                                    //     setConsumerNameError(true);
                                                    // }

                                                    // if (!e.target.value) {
                                                    //     setConsumerNameErrorMessage(
                                                    //         t("Please enter name")
                                                    //     );
                                                    // }
                                                    // else if (e.target.value?.trim().length < 3) {
                                                    //     setConsumerNameErrorMessage(
                                                    //         t("Please enter valid name")
                                                    //     );
                                                    // }

                                                    // if (e.target.value && e.target.value?.trim().length >= 3 && consumerNameErrorMessage) {
                                                    //     setConsumerNameErrorMessage("");
                                                    //     setConsumerNameValid(true);
                                                    // }
                                                    // else if (e.target.value && e.target.value?.trim().length >= 3 && !captchaTextErrorMessage) {
                                                    //     setConsumerNameErrorMessage("");
                                                    //     setConsumerNameValid(true);
                                                    // }
                                                    // else if (!e.target.value && consumerNameErrorMessage) {
                                                    //     setConsumerNameErrorMessage("");
                                                    //     setConsumerNameValid(false);
                                                    // }
                                                    // else {
                                                    //     setConsumerNameValid(false);
                                                    // }
                                                }}
                                                error={otpError}
                                            />
                                        </Grid>
                                        }
                                    </>
                                    }



                                    {isMobileVerified && <>
                                        <Grid size={12}>
                                            <TextField
                                                // required
                                                slotProps={{
                                                    input: {
                                                        readOnly: true,
                                                    },
                                                }}
                                                fullWidth
                                                name="supplyOfc"
                                                label={t("Supply Office")}
                                                type="text"
                                                id="supplyOfc"
                                                autoComplete="false"
                                                value={supplyOfc}
                                                onInput={(e) => {
                                                    setSupplyOfc(e.target.value);
                                                }}
                                                error={false}
                                            />
                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                required
                                                fullWidth
                                                name="addressLine1"
                                                label={t("Address Line 1")}
                                                type="text"
                                                id="addressLine1"
                                                slotProps={{
                                                    input: {
                                                        readOnly: true,
                                                    },
                                                }}
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                helperText={addressLine1ErrorMessage}
                                                value={addressLine1}
                                                onInput={(e) => {
                                                    setAddressLine1(e.target.value);
                                                    if (e.target.value && e.target.value.length >= 3) {
                                                        setAddressLine1Error(false);
                                                    } else {
                                                        setAddressLine1Error(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setAddressLine1ErrorMessage(
                                                            t("Please enter address")
                                                        );
                                                    }
                                                    else if (e.target.value?.trim().length < 3) {
                                                        setAddressLine1ErrorMessage(
                                                            t("Please enter valid address")
                                                        );
                                                    }

                                                    if (e.target.value && e.target.value?.trim().length >= 3 && addressLine1ErrorMessage) {
                                                        setAddressLine1ErrorMessage("");
                                                        setAddressLine1Valid(true);
                                                    }
                                                    else if (e.target.value && e.target.value?.trim().length >= 3 && !addressLine1ErrorMessage) {
                                                        setAddressLine1ErrorMessage("");
                                                        setAddressLine1Valid(true);
                                                    }
                                                    else if (!e.target.value && addressLine1ErrorMessage) {
                                                        setAddressLine1ErrorMessage("");
                                                        setAddressLine1Valid(false);
                                                    }
                                                    else {
                                                        setAddressLine1Valid(false);
                                                    }
                                                }}
                                                error={addressLine1Error}
                                            />
                                        </Grid>

                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                // required
                                                fullWidth
                                                name="addressLine2"
                                                slotProps={{
                                                    input: {
                                                        readOnly: true,
                                                    },
                                                }}
                                                label={t("Address Line 2")}
                                                type="text"
                                                id="addressLine2"
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                // helperText={captchaTextErrorMessage}
                                                value={addressLine2}
                                                onInput={(e) => {
                                                    setAddressLine2(e.target.value);
                                                }}
                                            // error={captchaTextError}
                                            />
                                        </Grid>




                                        <Grid size={{ xs: 12, sm: 6 }}>

                                            <Grid size={12}>
                                                <TextField
                                                    // required
                                                    fullWidth
                                                    name="email"
                                                    label={t("Email")}
                                                    type="text"
                                                    id="email"
                                                    autoComplete="false"
                                                    slotProps={{
                                                        input: {
                                                            readOnly: isEmailVerified,
                                                        },
                                                    }}
                                                    // inputProps={{ maxLength: 5 }}
                                                    helperText={consumerEmailErrorMessage}
                                                    value={consumerEmail}
                                                    onInput={(e) => {
                                                        setConsumerEmail(e.target.value);
                                                        if (!e.target.value) {
                                                            setConsumerEmailError(false);
                                                        }
                                                        else if (e.target.value && e.target.value.match(emailPattern)) {
                                                            setConsumerEmailError(false);
                                                        } else {
                                                            setConsumerEmailError(true);
                                                        }

                                                        if (!e.target.value) {
                                                            setConsumerEmailErrorMessage(
                                                                t("Please enter email")
                                                            );
                                                        }
                                                        else if (!e.target.value?.trim().match(emailPattern)) {
                                                            setConsumerEmailErrorMessage(
                                                                t("Please enter valid email")
                                                            );
                                                        }

                                                        if (!e.target.value) {
                                                            setConsumerEmailErrorMessage("");
                                                            setConsumerEmailValid(true);
                                                        }
                                                        else if (e.target.value && e.target.value?.trim().match(emailPattern) && consumerEmailErrorMessage) {
                                                            setConsumerEmailErrorMessage("");
                                                            setConsumerEmailValid(true);
                                                        }
                                                        else if (e.target.value && e.target.value?.trim().match(emailPattern) && !consumerEmailErrorMessage) {
                                                            setConsumerEmailErrorMessage("");
                                                            setConsumerEmailValid(true);
                                                        }
                                                        else if (!e.target.value && consumerEmailErrorMessage) {
                                                            setConsumerEmailErrorMessage("");
                                                            setConsumerEmailValid(false);
                                                        }
                                                        else {
                                                            setConsumerEmailValid(false);
                                                        }
                                                    }}
                                                    error={consumerEmailError}
                                                />
                                            </Grid>

                                            {consumerEmail.length > 0 && consumerEmailValid && !isEmailVerified &&
                                                <Grid container spacing={1} size={12}>
                                                    {isEmailOTPSent ?
                                                        <>
                                                            <Grid sx={{ mt: 2 }} size={12}>
                                                                <TextField
                                                                    // required
                                                                    fullWidth
                                                                    name="emailOtp"
                                                                    label={t("OTP")}
                                                                    type="text"
                                                                    id="emailOtp"
                                                                    autoComplete="false"
                                                                    // inputProps={{ maxLength: 5 }}
                                                                    helperText={emailOtpErrorMessage}
                                                                    value={emailOtp}
                                                                    onInput={(e) => {
                                                                        setEmailOtp(e.target.value);
                                                                    }}
                                                                    error={emailOtpError}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                {emailOtpVerifyLoading ?
                                                                    <LoadingButton
                                                                        fullWidth
                                                                        type="submit"
                                                                        size="large"
                                                                        color="primary"
                                                                        // onClick={() => setEmailOtpVerifyLoading(true)}
                                                                        loading={emailOtpVerifyLoading}
                                                                        loadingPosition="start"
                                                                        startIcon={<SendIcon />}
                                                                        variant="contained"
                                                                        sx={{ mt: 0, mb: 0 }}
                                                                    >
                                                                        <span>{t("Verifing OTP")}...</span>
                                                                    </LoadingButton>
                                                                    :
                                                                    <Button
                                                                        type="button"
                                                                        fullWidth
                                                                        variant="contained"
                                                                        sx={{ mt: 0, mb: 2 }}
                                                                        onClick={onClickVerifyEmailOTP}
                                                                    >
                                                                        {t("Verify OTP")}
                                                                    </Button>
                                                                }
                                                            </Grid>
                                                        </>
                                                        :
                                                        <Grid sx={{ mt: 2 }} size={6}>
                                                            {sendEmailOtpLoading ?
                                                                <LoadingButton
                                                                    fullWidth
                                                                    type="submit"
                                                                    size="large"
                                                                    color="primary"
                                                                    // onClick={() => setSendOtpLoading(true)}
                                                                    loading={sendEmailOtpLoading}
                                                                    loadingPosition="start"
                                                                    startIcon={<SendIcon />}
                                                                    variant="contained"
                                                                    sx={{ mt: 0, mb: 0 }}
                                                                >
                                                                    <span>{t("Sending OTP")}...</span>
                                                                </LoadingButton>
                                                                :
                                                                <Button
                                                                    type="button"
                                                                    fullWidth
                                                                    variant="contained"
                                                                    sx={{ mt: 0, mb: 0 }}
                                                                    onClick={onClickSendEmailOTP}
                                                                >
                                                                    {t("Send OTP")}
                                                                </Button>
                                                            }
                                                        </Grid>
                                                    }

                                                    <Grid sx={{ mt: 0 }} size={6}>
                                                        {
                                                            isEmailOTPSent ?
                                                                timer == 0 ?
                                                                    sendEmailOtpLoading ?
                                                                        <LoadingButton
                                                                            fullWidth
                                                                            type="submit"
                                                                            size="large"
                                                                            color="primary"
                                                                            // onClick={() => setSendOtpLoading(true)}
                                                                            loading={sendEmailOtpLoading}
                                                                            loadingPosition="start"
                                                                            startIcon={<SendIcon />}
                                                                            variant="contained"
                                                                            sx={{ mt: 0, mb: 0 }}
                                                                        >
                                                                            <span>{t("Sending OTP")}...</span>
                                                                        </LoadingButton>
                                                                        :
                                                                        <Button
                                                                            type="reset"
                                                                            fullWidth
                                                                            variant="contained"
                                                                            sx={{ mt: 0, mb: 0 }}
                                                                            color='error'
                                                                            onClick={onClickSendEmailOTP}
                                                                        >
                                                                            {t("Resend OTP")}
                                                                        </Button>
                                                                    :
                                                                    <Button
                                                                        type="reset"
                                                                        fullWidth
                                                                        disabled
                                                                        variant="contained"
                                                                        sx={{ mt: 0, mb: 0 }}
                                                                        color='error'
                                                                    >
                                                                        {t("Resend OTP in " + timer + " seconds")}
                                                                    </Button>
                                                                :
                                                                <Button
                                                                    type="reset"
                                                                    fullWidth
                                                                    variant="contained"
                                                                    sx={{ mt: 2, mb: 0 }}
                                                                    color='error'
                                                                    onClick={resetEmailForm}
                                                                >
                                                                    {t("Clear")}
                                                                </Button>
                                                        }
                                                    </Grid>
                                                </Grid>
                                            }
                                        </Grid>


                                        <Grid size={{ xs: 12, sm: 6 }}>
                                            <TextField
                                                select
                                                required
                                                fullWidth
                                                name="problemType"
                                                label={t("Problem Type")}
                                                type="text"
                                                id="problemType"
                                                autoComplete="false"
                                                // inputProps={{ maxLength: 5 }}
                                                helperText={problemTypeErrorMessage}
                                                value={problemType}
                                                onChange={(e) => {
                                                    setProblemType(e.target.value);
                                                    if (e.target.value && e.target.value.length >= 3) {
                                                        setProblemTypeError(false);
                                                    } else {
                                                        setProblemTypeError(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setProblemTypeErrorMessage(
                                                            t("Please select problem type")
                                                        );
                                                    }
                                                    else if (e.target.value?.trim().length < 3) {
                                                        setProblemTypeErrorMessage(
                                                            t("Please select problem type")
                                                        );
                                                    }

                                                    if (e.target.value && e.target.value?.trim().length >= 3 && problemTypeErrorMessage) {
                                                        setProblemTypeErrorMessage("");
                                                        setProblemTypeValid(true);
                                                    }
                                                    else if (e.target.value && e.target.value?.trim().length >= 3 && !problemTypeErrorMessage) {
                                                        setProblemTypeErrorMessage("");
                                                        setProblemTypeValid(true);
                                                    }
                                                    else if (!e.target.value && problemTypeErrorMessage) {
                                                        setProblemTypeErrorMessage("");
                                                        setProblemTypeValid(false);
                                                    }
                                                    else {
                                                        setProblemTypeValid(false);
                                                    }
                                                }}
                                                error={problemTypeError}
                                            >
                                                {problemTypes.map((option, index) => (
                                                    <MenuItem key={index.toString()} value={option}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Grid>


                                        <Grid size={12}>
                                            <TextField
                                                multiline
                                                minRows={3}
                                                required
                                                fullWidth
                                                name="problemDesc"
                                                label={t("Problem Description")}
                                                type="text"
                                                id="problemDesc"
                                                autoComplete="false"
                                                slotProps={{ htmlInput: { maxLength: 500 } }}
                                                helperText={problemDescErrorMessage}
                                                value={problemDesc}
                                                onInput={(e) => {
                                                    setProblemDesc(e.target.value);
                                                    setProblemDescCount(e.target.value.length);
                                                    if (e.target.value && e.target.value.length >= 3 && e.target.value.length <= 500) {
                                                        setProblemDescError(false);
                                                    } else {
                                                        setProblemDescError(true);
                                                    }

                                                    if (!e.target.value) {
                                                        setProblemDescErrorMessage(
                                                            t("Please enter problem description")
                                                        );
                                                    }
                                                    else if (e.target.value?.trim().length < 3 && e.target.value.length > 500) {
                                                        setProblemDescErrorMessage(
                                                            t("Please enter valid problem description")
                                                        );
                                                    }

                                                    if (e.target.value && e.target.value?.trim().length >= 3 && problemTypeErrorMessage) {
                                                        setProblemDescErrorMessage("");
                                                        setProblemDescValid(true);
                                                    }
                                                    else if (e.target.value && e.target.value?.trim().length >= 3 && e.target.value.length <= 500 && !problemTypeErrorMessage) {
                                                        setProblemDescErrorMessage("");
                                                        setProblemDescValid(true);
                                                    }
                                                    else if (!e.target.value && problemTypeErrorMessage) {
                                                        setProblemDescErrorMessage("");
                                                        setProblemDescValid(false);
                                                    }
                                                    else {
                                                        setProblemDescValid(false);
                                                    }
                                                }}
                                                error={problemDescError}
                                            />
                                            <FormHelperText style={{ textAlign: "right" }}>{problemDescCount}/500</FormHelperText>
                                        </Grid>

                                        <Grid size={12}>
                                            <FormControl sx={{ m: 3, ml: 0 }} error={grievanceOfcError} variant="standard">
                                                <FormLabel id="demo-error-radios">Where do you want to apply?<span style={{ color: "#f00" }}> *</span></FormLabel>
                                                <RadioGroup
                                                    aria-labelledby="demo-error-radios"
                                                    name="quiz"
                                                    value={grievanceOfc}
                                                    onChange={handleGrievanceOfcChange}
                                                >
                                                    <FormControlLabel value="RGRO" control={<Radio />} label={<p>RGRO <span style={{ color: "#f00" }}>(All proceedings shall be held at Local Regional Office)</span></p>} />
                                                    <FormControlLabel value="CGRO" control={<Radio />} label={<p>CGRO <span style={{ color: "#f00" }}>(All proceedings shall be held at Vidyut Bhaban)</span></p>} />
                                                </RadioGroup>
                                                <FormHelperText>{grievanceOfcHelperText}</FormHelperText>
                                            </FormControl>
                                        </Grid>

                                        <FormControl sx={{}} error={supportingDocError} variant="standard">
                                            <FormLabel id="demo-error-radios">Upload Supporting Signed Documents/Application Letter<span style={{ color: "#f00" }}> *</span></FormLabel>
                                            <FormHelperText style={{ color: '#000' }}>Upload PDF File of within 1MB</FormHelperText>
                                            <Button
                                                component="label"
                                                role={undefined}
                                                variant="contained"
                                                tabIndex={-1}
                                                startIcon={<CloudUploadIcon />}
                                            >
                                                Upload PDF
                                                <VisuallyHiddenInput
                                                    type="file"
                                                    onChange={handleGrievanceFileChange}
                                                    accept="application/pdf"
                                                />
                                            </Button>

                                            <FormHelperText>{!supportingDocError ? supportingDoc?.name : supportingDocErrorMsg}</FormHelperText>
                                        </FormControl>
                                    </>
                                    }


                                </Grid>
                                {!isMobileFetched &&
                                    <>
                                        {verifyLoading ?
                                            <LoadingButton
                                                fullWidth
                                                type="submit"
                                                size="large"
                                                color="primary"
                                                onClick={() => setVerifyLoading(true)}
                                                loading={verifyLoading}
                                                loadingPosition="start"
                                                startIcon={<SendIcon />}
                                                variant="contained"
                                                sx={{ mt: 3, mb: 2 }}
                                            >
                                                <span>{t("Verifying")}...</span>
                                            </LoadingButton>
                                            :
                                            <Button
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                sx={{ mt: 3, mb: 2 }}
                                            >
                                                {t("Verify")}
                                            </Button>
                                        }
                                    </>
                                }


                                {isMobileFetched && !isMobileVerified &&
                                    <Grid container spacing={2}>
                                        {isOTPSent ?
                                            <Grid size={6}>
                                                {otpVerifyLoading ?
                                                    <LoadingButton
                                                        fullWidth
                                                        type="submit"
                                                        size="large"
                                                        color="primary"
                                                        onClick={() => setOtpVerifyLoading(true)}
                                                        loading={otpVerifyLoading}
                                                        loadingPosition="start"
                                                        startIcon={<SendIcon />}
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                    >
                                                        <span>{t("Verifing OTP")}...</span>
                                                    </LoadingButton>
                                                    :
                                                    <Button
                                                        type="button"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        onClick={onClickVerifyOTP}
                                                    >
                                                        {t("Verify OTP")}
                                                    </Button>
                                                }
                                            </Grid>
                                            :
                                            <Grid size={6}>
                                                {sendOtpLoading ?
                                                    <LoadingButton
                                                        fullWidth
                                                        type="submit"
                                                        size="large"
                                                        color="primary"
                                                        onClick={() => setSendOtpLoading(true)}
                                                        loading={sendOtpLoading}
                                                        loadingPosition="start"
                                                        startIcon={<SendIcon />}
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                    >
                                                        <span>{t("Sending OTP")}...</span>
                                                    </LoadingButton>
                                                    :
                                                    <Button
                                                        type="button"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        onClick={onClickSendOTP}
                                                    >
                                                        {t("Send OTP")}
                                                    </Button>
                                                }
                                            </Grid>
                                        }
                                        <Grid size={6}>
                                            {
                                                isOTPSent ?
                                                    timer == 0 ?
                                                        sendOtpLoading ?
                                                            <LoadingButton
                                                                fullWidth
                                                                type="submit"
                                                                size="large"
                                                                color="primary"
                                                                onClick={() => setSendOtpLoading(true)}
                                                                loading={sendOtpLoading}
                                                                loadingPosition="start"
                                                                startIcon={<SendIcon />}
                                                                variant="contained"
                                                                sx={{ mt: 3, mb: 2 }}
                                                            >
                                                                <span>{t("Sending OTP")}...</span>
                                                            </LoadingButton>
                                                            :
                                                            <Button
                                                                type="reset"
                                                                fullWidth
                                                                variant="contained"
                                                                sx={{ mt: 3, mb: 2 }}
                                                                color='error'
                                                                onClick={onClickSendOTP}
                                                            >
                                                                {t("Resend OTP")}
                                                            </Button>
                                                        :
                                                        <Button
                                                            type="reset"
                                                            fullWidth
                                                            disabled
                                                            variant="contained"
                                                            sx={{ mt: 3, mb: 2 }}
                                                            color='error'
                                                        >
                                                            {t("Resend OTP in " + timer + " seconds")}
                                                        </Button>
                                                    :
                                                    <Button
                                                        type="reset"
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{ mt: 3, mb: 2 }}
                                                        color='error'
                                                        onClick={resetFrom}
                                                    >
                                                        {t("Cancel")}
                                                    </Button>
                                            }
                                        </Grid>
                                    </Grid>
                                }

                                {isMobileVerified &&
                                    <Grid container spacing={2}>
                                        <Grid size={6}>
                                            {finalSubmitLoading ?
                                                <LoadingButton
                                                    fullWidth
                                                    type="submit"
                                                    size="large"
                                                    color="primary"
                                                    onClick={() => setFinalSubmitLoading(true)}
                                                    loading={finalSubmitLoading}
                                                    loadingPosition="start"
                                                    startIcon={<SendIcon />}
                                                    variant="contained"
                                                    sx={{ mt: 3, mb: 2 }}
                                                >
                                                    <span>{t("Submitting Grievance")}...</span>
                                                </LoadingButton>
                                                :
                                                <Button
                                                    type="button"
                                                    fullWidth
                                                    variant="contained"
                                                    sx={{ mt: 3, mb: 2 }}
                                                    onClick={onClickFinalSubmit}
                                                >
                                                    {t("Submit")}
                                                </Button>
                                            }
                                        </Grid>
                                        <Grid size={6}>
                                            {
                                                <Button
                                                    type="reset"
                                                    fullWidth
                                                    variant="contained"
                                                    sx={{ mt: 3, mb: 2 }}
                                                    color='error'
                                                    onClick={resetFrom}
                                                >
                                                    {t("Cancel")}
                                                </Button>
                                            }
                                        </Grid>
                                    </Grid>
                                }
                            </Box>
                        </div>
                    }
                </Box>
                {/* <Copyright sx={{ mt: 5 }} /> */}
            </Container>
        </ThemeProvider>
    );
}